// import { useAuth } from 'context/auth.context';
import { PostCreateOrLoadUserRequest } from 'core/models/users/post-create-load-user.model';
import { OnboardingPhases, UserRoles } from 'core/models/users/user.model';
import { UserV1BaseServerRepo } from 'core/repository/base-server/v1/user.repo';
import { ProjectV1BaseServerRepo } from 'core/repository/base-server/v1/project.repo';
import { DateTime } from 'luxon';
import { useState, useEffect } from 'react';
import { ROUTES } from 'routes';
import { ProgressStage } from './ApplicationProgressBox';
import { usePrivy } from '@privy-io/react-auth';
// import { useNavigate } from 'react-router-dom';

export const useApplication = () => {
  const { user } = usePrivy();
  const [progressData, setProgressData] = useState<ProgressStage[]>();
  const [lastUpdated, setLastUpdated] = useState<DateTime>(DateTime.now());
  const [onboardingPhase, setOnboardingPhase] = useState<OnboardingPhases>();
  const [userRoles, setUserRoles] = useState<UserRoles>();
  // const navigate = useNavigate();

  async function fetchProgressData() {
    const userRequest: PostCreateOrLoadUserRequest = {};
    const appUser = await new UserV1BaseServerRepo().createOrLoad(userRequest);
    let projectData = null;
    if (appUser.roles?.includes('PROJECT_OWNER')) {
      const appProjects = await new ProjectV1BaseServerRepo().getProjects();
      // console.log('appProjects--',appProjects)
      if (appProjects.data.length) {
        projectData = appProjects.data[0];
      }
      // if (
      //   appProjects.data.length &&
      //   appProjects.data[0].status === 'APPROVED'
      // ) {
      //   navigate(ROUTES.DASHBOARD);
      // }
    }
    setUserRoles(appUser.roles);
    setOnboardingPhase(appUser.onboardingPhase);
    setLastUpdated(DateTime.now());
    switch (appUser.onboardingPhase) {
      case OnboardingPhases.USER_APPLICATION_SUBMITTED:
        appUser.roles?.includes('PROJECT_OWNER')
          ? setProgressData([
              { id: 1, status: 'submitted' },
              { id: 2, status: 'pending' },
              { id: 3, status: 'pending' },
            ])
          : setProgressData([
              { id: 1, status: 'submitted' },
              { id: 2, status: 'pending' },
            ]);
        break;
      case OnboardingPhases.DONE:
        appUser.roles?.includes('PROJECT_OWNER')
          ? setProgressData(
              projectData
                ? [
                    { id: 1, status: 'complete' },
                    {
                      id: 2,
                      status:
                        projectData?.status === 'SUBMITTED'
                          ? 'submitted'
                          : projectData?.status === 'APPROVED'
                            ? 'complete'
                            : projectData?.status === 'REJECTED'
                              ? 'rejected'
                              : 'pending',
                      route: ROUTES.ONBOARDING_PROJECT as keyof typeof ROUTES,
                      remarks:
                        projectData?.status === 'REJECTED'
                          ? projectData?.remarks
                          : undefined,
                      buttonText:
                        projectData?.status === 'REJECTED'
                          ? 'Resubmit Project'
                          : undefined,
                    },
                    {
                      id: 3,
                      status:
                        projectData?.status === 'APPROVED'
                          ? 'complete'
                          : 'pending',
                      // route: ROUTES.DASHBOARD as keyof typeof ROUTES,
                      // buttonText:
                      //   projectData?.status === 'APPROVED'
                      //     ? 'Dashboard'
                      //     : undefined,
                    },
                  ]
                : [
                    { id: 1, status: 'complete' },
                    {
                      id: 2,
                      status: 'pending',
                      route: ROUTES.ONBOARDING_PROJECT as keyof typeof ROUTES,
                      buttonText: 'Onboard Your Project',
                    },
                    { id: 3, status: 'pending' },
                  ]
            )
          : setProgressData([
              { id: 1, status: 'complete' },
              {
                id: 2,
                status: 'complete',
                // route: ROUTES.DASHBOARD as keyof typeof ROUTES,
                buttonText: 'Dashboard',
              },
            ]);
        break;
      // case OnboardingPhases.DONE:
      //   appUser.roles?.includes('PROJECT_OWNER')?
      //   setProgressData([
      //     { id: 1, status: 'complete' },
      //     { id: 2, status: 'complete' },
      //     {
      //       id: 3,
      //       status: 'complete',
      //       route: ROUTES.DASHBOARD as keyof typeof ROUTES,
      //       buttonText: 'Dashboard',
      //     },
      //   ])
      //   :setProgressData([
      //     { id: 1, status: 'complete' },
      //     {
      //       id: 2,
      //       status: 'complete',
      //       route: ROUTES.DASHBOARD as keyof typeof ROUTES,
      //       buttonText: 'Dashboard',
      //     },
      //   ]);
      //   break;
      default:
        appUser.roles?.includes('PROJECT_OWNER')
          ? setProgressData([
              { id: 1, status: 'pending' },
              { id: 2, status: 'pending' },
              { id: 3, status: 'pending' },
            ])
          : setProgressData([
              { id: 1, status: 'pending' },
              { id: 2, status: 'pending' },
            ]);
    }
  }

  useEffect(() => {
    if (!user) return;
    fetchProgressData();
  }, [user]);

  useEffect(() => {
    const timeout = setTimeout(() => fetchProgressData(), 10000);
    return () => clearTimeout(timeout);
  }, [progressData]);

  return { progressData, onboardingPhase, lastUpdated, userRoles };
};
